<template>
  <ul class="grid gap-[0.75em]">
    <li v-for="item in items" :key="item" class="flex gap-2">
      <app-icon
        class="relative shrink-0"
        icon="ph:check-circle-fill"
        :size="iconSize"
        :style="{ top: `${iconSize / 5}px` }"
      />
      <app-text-markdown v-if="markdown" lazy :value="item as string" />
      <span v-else v-html="item" />
    </li>
  </ul>
</template>

<script lang="ts" setup>
import type { I18nMessage } from "@pollen/core/model/i18n.model";

withDefaults(
  defineProps<{
    items: I18nMessage[];
    iconSize?: number;
    markdown?: boolean;
  }>(),
  {
    iconSize: 16,
  },
);
</script>
